// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DxfExport div.help-text {\n    font-style: italic;\n    padding-bottom: 0.5em;\n}\n\n.DxfExport div.export-settings {\n    font-size: small;\n}\n\n.DxfExport span.input-frame {\n    border: 1px solid #bbb;\n    padding: 0.25em;\n    background-color: white;\n    display: inline-flex;\n    align-items: center;\n}\n\n.DxfExport span.input-frame input {\n    border: 0;\n    flex: 1;\n    width: 8ch;\n    min-width: 0;\n}\n", ""]);
// Exports
module.exports = exports;
